<template>
  <div class="page dataList">
    <div class="p16">
      <p style="font-weight: bold;">门店数据<span class="moneys fontSize14">（数据指标可能存在几分钟延迟）</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="more-boxs">
              <div class="boxs mb10 br10" >
                <div class="titles">
                  <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>数据汇总</i></p>
                  <v-date @time="change" class="ml10"></v-date>
                </div>
                <el-row class="rows pb20">
                    <el-col class="cols" :span="4">
                        <p class="van-text text van-ellipsi">现金总收款(现金)</p>
                        <p class="van-label">{{amount.cashIncomeAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text van-ellipsi">经营总额(现金)</p>
                        <p class="van-label">{{amount.shopBizAchAmountCash}}</p>
                    </el-col>
                     <el-col class="cols" :span="4">
                        <p class="van-text text van-ellipsi">消费业绩(O2O)</p>
                        <p class="van-label">{{amount.o2oAchAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text van-ellipsi">消费业绩(会员卡)</p>
                        <p class="van-label">{{amount.consumeAchAmountWallet}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text van-ellipsi">消费业绩(套餐卡)</p>
                        <p class="van-label">{{amount.consumeAchAmountNumberCard}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text van-ellipsi">消费业绩(IC卡)</p>
                        <p class="van-label">{{amount.consumeAchAmountIcCard}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">业绩总收入</p>
                        <p class="van-label">{{amount.shopAchAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">工资提成汇总</p>
                        <p class="van-label">{{amount.deductAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">费用汇总</p>
                        <p class="van-label">{{amount.expensesAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">总开支</p>
                        <p class="van-label">{{amount.outAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">营业利润</p>
                        <p class="van-label">{{amount.businessProfitAmount}}</p>
                    </el-col>
                </el-row>
                
              </div>
              <div class="boxs mb10 pb20 br10">
                  <div class="space-between">
                    <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>费用汇总</i></p>
                  </div>
                  <el-row class="rows">
                    <el-col class="cols" :span="4">
                        <p class="van-text text">门店开支</p>
                        <p class="van-label">{{amount.invoiceAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">产品采购金额</p>
                        <p class="van-label">{{amount.productPurchaseAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">折旧金额</p>
                        <p class="van-label">{{amount.depleteAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">品牌管理费</p>
                        <p class="van-label">{{amount.brandManageAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">媒体机费</p>
                        <p class="van-label">{{amount.mediaAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">租金</p>
                        <p class="van-label">{{amount.rentAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">物业费</p>
                        <p class="van-label">{{amount.houseManageAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">充值赠送</p>
                        <p class="van-label">{{amount.rechargeGiveAmountSum}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">门店管理费</p>
                        <p class="van-label">{{amount.shopServiceAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">短信服务费</p>
                        <p class="van-label">{{amount.smsServiceAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">其他开支</p>
                        <p class="van-label">{{amount.otherExpendAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">合同签署费</p>
                        <p class="van-label">{{amount.contractFeeAmount}}</p>
                    </el-col>
                  </el-row>
                </div>
              <div class="boxs mb10 br10" :class="[xjFlag ? 'pb20':'']"  @click="lookList('XJ')">
                <div class="align-items pr16">
                  <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>现金收款汇总</i></p>
                  <p><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
                </div>
                <el-row class="rows" v-show="xjFlag">
                    <el-col class="cols" :span="4">
                        <p class="van-text text">总收款</p>
                        <p class="van-label">{{amount.cashIncomeAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text text">经营总额(现金)</p>
                        <p class="van-label">{{amount.shopBizAchAmountCash}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text">充值金额</p>
                        <p class="van-label">{{amount.rechargeAmount}}</p>
                    </el-col>
                    <el-col class="cols" :span="4">
                        <p class="van-text">套餐销售金额</p>
                        <p class="van-label">{{amount.cardSaleAmountCash}}</p>
                    </el-col>
                </el-row>
              </div>
            <div class="mb10 br10 boxs" :class="[tkFlag ? 'pb20':'']" @click="lookList('TK')">
              <div class="align-items pr16">
                <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>退款汇总</i></p>
                <p ><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
              </div>
              <el-row class="rows" v-show="tkFlag">
                <el-col class="cols" :span="4">
                    <p class="van-text text">退款总额</p>
                    <p class="van-label">{{amountBO.refundAmountCash}}</p>
                </el-col>
                <el-col class="cols" :span="4">
                    <p class="van-text text">消费退款(现金)</p>
                    <p class="van-label">{{amountBO.refundAmountServeProductCash}}</p>
                </el-col>
                <el-col class="cols" :span="4">
                    <p class="van-text text">修护退款(现金)</p>
                    <p class="van-label">{{amountBO.refundAmountRepairCash}}</p>
                </el-col>
                <el-col class="cols" :span="4">
                    <p class="van-text text">套餐退款(现金)</p>
                    <p class="van-label">{{amountBO.refundAmountNumberCardCash}}</p>
                </el-col>
                <el-col class="cols" :span="4">
                    <p class="van-text text">提现(会员卡)</p>
                    <p class="van-label">{{amountBO.withdrawAmount}}</p>
                </el-col>
                <el-col class="cols" :span="4">
                    <p class="van-text text">冻结差额(会员卡)</p>
                    <p class="van-label">{{amountBO.freezeAmountDiff}}</p>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="boxs mb10 br10" :class="[paywayFlag ? 'pb20':'']"  @click="lookList('SK')">
              <div class="align-items pr16">
                <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>收款方式汇总</i></p>
                <p><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
              </div>
              <div class="plr16">
              <el-table :data="paywaySetBOList" border="" max-height="285px" header-cell-class-name="table_header_bgcolor" v-show="paywayFlag">
                <el-table-column prop="payName" label="支付方式"></el-table-column>
                <el-table-column prop="payAmount" label="支付金额（元）"></el-table-column>
              </el-table>
            </div>
          </div>
          <div class="boxs mb10 br10" :class="[invoiceFlag ? 'pb20':'']" @click="lookList('KZ')">
            <div class="align-items pr16">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>开支汇总</i></p>
              <p ><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plr16">
              <el-table :data="invoiceBOList" border="" header-cell-class-name="table_header_bgcolor" max-height="285px" v-show="invoiceFlag">
                <el-table-column prop="categoryName" label="开支分类"></el-table-column>
                <el-table-column prop="applyAmount" label="申请金额"></el-table-column>
                <el-table-column prop="auditAmount" label="审批金额"></el-table-column>
                <el-table-column prop="refuseAmount" label="拒绝金额"></el-table-column>
                <el-table-column prop="maxMoneyPreMonth" label="每月上限"></el-table-column>
                <!-- <el-table-column prop="overFlag" label="是否超标">
                  <template slot-scope="scope">{{ scope.row.overFlag ? '是':'否' }}</template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
          <div class="boxs mb10 br10" :class="[itemFlag ? 'pb20':'']" @click="lookList('FW')">
            <div class="align-items pr16">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>服务项目汇总</i></p>
              <p ><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plr16">
              <el-table :data="itemDataSumVOList" max-height="285px" v-show="itemFlag" border="" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="categoryName" label="类型">
                  <template slot-scope="scope">
                    <p class="van-text" v-if="scope.row.itemType == 'serve'">服务</p>
                    <p class="van-text" v-if="scope.row.itemType == 'product'">产品</p>
                    <p class="van-text" v-if="scope.row.itemType == 'card'">卡项</p>
                    <p class="van-text" v-if="scope.row.itemType == 'recharge'">充值</p>
                    <p class="van-text" v-if="scope.row.itemType == 'repair'">修护</p>
                    <p class="van-text" v-if="scope.row.itemType == 'cardreduce'">套餐划卡</p>
                    <p class="van-text" v-if="scope.row.itemType == 'papercard'">纸质划卡</p>
                  </template>
                </el-table-column>
                <el-table-column prop="applyAmount" label="名称">
                  <template slot-scope="scope">
                    <p
                      class="van-text"
                      v-if="scope.row.itemType == 'recharge'"
                    >{{ scope.row.itemName !='汇总'?'门店充值':scope.row.itemName }}</p>
                    <p class="van-text" v-else>{{ scope.row.itemName }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="totalNum" label="数量"></el-table-column>
                <el-table-column prop="achAmount" label="业绩"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";

export default {
  mixins: [minxin],
  data() {
    return {
      amount: {},
      downloadUrl: require("../../../assets/images/home/data.png"),
      amountBO: {},
      paywaySetBOList: [],
      invoiceBOList: [],
      orderItemSumBOList: [],
      itemDataSumVOList: [],
      query: {
        beginTime: new Date(),
        endTime: new Date()
      },
      xjFlag: false,
      tkFlag: false,
      invoiceFlag: false,
      itemFlag: false,
      paywayFlag: false,
    };
  },
  components: {},
  created() {},
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.xjFlag = false;
      this.tkFlag = false;
      this.invoiceFlag = false;
      this.itemFlag = false;
      this.paywayFlag = false;
      this.pageDetailByShop();
    },
    pageDetailByShop() {
      this.$api.post(this.$url.report.shopDataDetail, {
        beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(res => {
        this.shopName = res.shopName;
        this.amount = res.businessProfitVO;
        console.log(this.amountBO,"sssss")
        this.amountBO = {
          refundAmountCash: res.refundAmountCash,
          refundAmountNumberCardCash: res.refundAmountNumberCardCash,
          refundAmountRepairCash: res.refundAmountRepairCash,
          refundAmountServeProductCash: res.refundAmountServeProductCash,
          withdrawAmount: res.withdrawAmount,
          freezeAmountDiff: res.freezeAmountDiff
        };
      }).catch(error => {});
    },
    invoiceList () {
      this.$api.post(this.$url.report.collectList, {
          beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(res => {
        this.invoiceBOList = res;
      }).catch(error => {});
    },
    itemList () {
      this.$api.post(this.$url.report.item, {
          beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(res => {
        this.itemDataSumVOList = res;
      }).catch(error => {});
    },
    paywayList () {
      this.$api.post(this.$url.report.payway, {
          beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(res => {
        this.paywaySetBOList = res;
      }).catch(error => {});
    },
    lookList (code) {
		console.log('11',code)
      // 查看列表
      if ( code == 'XJ') {
        this.xjFlag =!this.xjFlag;
      } else if (code == 'TK') {
        this.tkFlag = !this.tkFlag;
		console.log('11',this.tkFlag)
      } else if (code == 'KZ') {
		  this.invoiceFlag = !this.invoiceFlag;
		  if(this.invoiceFlag)
		  {
		  	this.invoiceList();
		  }
      } else if (code == 'FW') {
		  this.itemFlag = !this.itemFlag;
		  if(this.itemFlag)
		  {
		  	this.itemList();
		  }
      } else if (code == 'SK') {
		   this.paywayFlag =!this.paywayFlag;
		   if(this.paywayFlag)
		   {
			   this.paywayList();
		   }
      }
	  console.log('11',this.tkFlag)
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  overflow: auto;
  height: calc(100vh - 150px);
}
.mains-content {
  height: calc(100% - 72px);
}
.boxs-left {
  margin-right: 10px;
}
.boxs-center {
  margin-right: 10px;
}
.boxs-right {
  margin-left: 10px;
}
.boxs {
  background: #fff;
  // .titles {
  //   font-size: 18px;
  //   font-weight: bold;
  // }
  .titles {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
}
</style>